import TableOptions from './tableOptions';
export default TableOptions;